import EditMemberModal from './EditMemberModal';

export default EditMemberModal;
